import { v4 as uuidv4 } from 'uuid';

import { AggregateOnType, Period, Quantity } from './types';

import { AggregateOn } from 'components/enums';

// eslint-disable-next-line comma-spacing
export const ObjectKeys = <O extends object>(o: O) =>
  Object.keys(o) as (keyof typeof o)[];

export const getTotals = (
  data: { periods: Period[] }[],
  aggregate: AggregateOnType
) => {
  let totals: number[] = [];

  if (data.length) {
    data.forEach(({ periods }) => {
      periods.forEach((period, i) => {
        if (totals[i] === undefined) {
          totals.push(period.hours);
        } else {
          totals[i] += period.hours;
        }
      });
    });
  } else {
    const columns = aggregate === AggregateOn.MONTH ? 12 : 13;
    totals = Array(columns).fill(0);
  }

  const yearTotal = totals.reduce((prev, hours) => prev + hours, 0);
  totals.push(yearTotal);

  return totals.map((total) => ({ id: uuidv4(), total }));
};

// temporary fix, loop through datasets that have periods. ideally data should always be populated from backend.
export const getPeriods = (quantities: Quantity[]) =>
  quantities.filter(({ data }) => data.length > 0)?.[0]?.data[0].periods ?? [];
